import { NavigationContext } from "@/providers/navigationProvider";
import { useContext } from 'react';
import Link from "next/link";
import styles from './styles.module.scss';

const DemoButton = () =>{
    const context = useContext(NavigationContext);
    const {setOpen} = context || {};

    const handleClick = () => {
        setOpen(false);
    }
    return(
        <Link onClick={handleClick} href={"/demo"} className={`${styles.demoButton} button primary-fill `}>
            Book a Demo
        </Link>
    );
}

export default DemoButton;